import styled, { css } from "styled-components";
import commonProps from "./_commonProps";
import PropTypes from "prop-types";
import Link from "./Link";

var Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-10c4wfo-0"
})(["", ";letter-spacing:0.2px;", ";", "{text-decoration:underline;font-weight:normal;color:inherit;&:hover:before{visibility:hidden;}}"], commonProps, function (props) {
  return props.paragraph && css(["display:block;line-height:1.5;margin:1em 0;"]);
}, Link);

Text.propTypes = {
  paragraph: PropTypes.bool
};

export default Text;